import { serverConnection } from "../server/ServerConnectionService";
import { usersService } from "../UsersService";
import { PeerCurrentFineshedMessage, SessionPermissionsMessage } from "../../../messages/session/SessionMessages";
import { createModelFromPath, getModelFromAbsolutePath } from "@modules/model";
export class PeerSessionMessageHandler {
    constructor(peerMgr) {
        this.peerMgr = peerMgr;
        this.handleServerMessage = (msg) => {
            switch (msg.channel) {
                case "session:current":
                    this.handleCurrent(msg);
                    break;
                case "session:connect":
                    this.handleConnect(msg.payload);
                    break;
                case "session:disconnect":
                    this.handleDisconnect(msg);
                    break;
            }
        };
        this.handleConnect = (members) => {
            const localClientId = usersService.getLocalUser().clientId;
            try {
                for (const member of members) {
                    if (member.clientId === localClientId)
                        continue;
                    let room = getModelFromAbsolutePath(member.roomModelAbsolutePath);
                    if (room === undefined) {
                        room = createModelFromPath(member.roomModelAbsolutePath); // ToDo: Do we want NO_MESSAGING here?
                        room.flushMessages();
                    }
                    const existingPeer = this.peerMgr.getPeer(member.clientId);
                    if ((existingPeer === null || existingPeer === void 0 ? void 0 : existingPeer.remoteClientIdx) === member.clientIdx) {
                        existingPeer.onRoomChanged(room.getUID());
                        continue;
                    }
                    if (existingPeer !== undefined) {
                        this.peerMgr.removePeer(member.clientId, true);
                    }
                    // Don't wait to add peer
                    // Both clients must agree on which side creates the data channels.
                    const isInitiator = localClientId < member.clientId;
                    void this.peerMgr.createPeer(localClientId, member.clientId, member.clientIdx, isInitiator).then((peer) => {
                        peer.onRoomChanged(room.getUID());
                    });
                }
            }
            catch (error) {
                console.error("[multiplayer]", error);
            }
        };
        serverConnection.messageDelegate.add(this.handleServerMessage);
    }
    handleCurrent(data) {
        var _a;
        this.peerMgr.connection.send(new SessionPermissionsMessage((_a = data.payload.permissions) !== null && _a !== void 0 ? _a : []));
        this.handleConnect(data.payload.members);
        this.peerMgr.connection.send(new PeerCurrentFineshedMessage(data.payload.roomId));
    }
    handleDisconnect(data) {
        const clientId = data.payload.clientId;
        this.peerMgr.removePeer(clientId, true);
    }
}
